{
  "somethingWentWrong": "Щось пішло не так 🤕",
  "forbidden": "Ваш доступ до кабінету призупинено менеджером"
}
